import {
  ApplicationConfig,
  inject,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  provideCheckNoChangesConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideOptimus } from '@openng/optimus-ui/config';
import Aura from '@openng/optimus-ui-themes/aura';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { AuthService } from './services/auth.service';
import { environment } from '../environments/environment';

function runAuthInitializer(): Promise<void> {
  const authService = inject(AuthService);
  return authService.resolveUserFromSession();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    provideOptimus({
      theme: {
        preset: Aura,
      },
    }),
    provideAppInitializer(runAuthInitializer),
    // Fails loudly on any template binding that changed without notifying change detection —
    // the only reliable way to catch a missed update in a zoneless app.
    ...(environment.production
      ? []
      : [provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })]),
  ],
};
